import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { ShieldCheck, Lock, CreditCard, Star, XCircle, CheckCircle2, ArrowRight } from 'lucide-react';
export const Hero = () => {
  return <section className="bg-bg-base px-4 pt-4 pb-7 md:pt-16 md:pb-16 overflow-hidden" data-id="element-304" data-mp="rrp8ibgwjnl2">
      <div className="max-w-[700px] mx-auto text-center space-y-2.5 md:space-y-6" data-id="element-305" data-mp="wr25vq5egd1w">
        <FadeIn data-id="element-306" data-mp="wt669y43atxf">
          <div className="space-y-2 md:space-y-4" data-id="element-307" data-mp="3v97gciwoculh">
            <div className="inline-flex items-center gap-1.5 bg-bg-card text-brandGold font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full border border-brandGold/40" data-id="element-308" data-mp="3vaijcgiapybj">
              <span className="text-sm md:text-base" data-id="element-309" data-mp="e0u7flcnaas1">🎨</span>
              <span className="text-[8.5px]" data-id="element-310" data-mp="e2f2rd6s9xqy">
                MEGAPACK COLORIMETRÍA LISTA™
              </span>
            </div>
            <h1 className="font-hero font-bold uppercase text-[30px] md:text-[56px] leading-[1.08] tracking-[0.5px] text-txt-primary mx-auto max-w-[20ch] px-2 pt-3 pb-1" data-id="element-311" data-mp="1kj8vm6gmdlsc">
              <span className="block" data-id="element-312" data-mp="1h9sia9chfmxh">CURSO COMPLETO</span>
              <span className="block text-brandGold" data-id="element-313" data-mp="1capo5jy1j14a">DE COLORIMETRÍA MASCULINA.</span>
              <span className="block" data-id="element-314" data-mp="189dsawokpjnn">ORGANIZADO EN UN SOLO LUGAR.</span>
            </h1>

            <p className="text-txt-body text-[12.5px] md:text-[16px] leading-[1.4] md:leading-[1.7] font-sans px-3" data-id="element-315" data-mp="13ajany2ce154">
              15 Módulos en Video · 4 Manuales Profesionales · 5 Bonos · Acceso inmediato
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-316" data-mp="tj6jz9sa5h0o">
          <a href="#pricing" className="block cursor-pointer relative" data-id="element-317" data-mp="tiwt7jzev5tx">
            <div className="absolute inset-0 bg-brandGold/15 blur-[40px] rounded-full" data-id="element-318" data-mp="om6b6r41q05v"></div>
            <div className="absolute inset-y-0 -inset-x-10 bg-brandGold/10 blur-[28px] rounded-full" data-id="element-319" data-mp="klmh5werrcny"></div>
            <img src="https://cdn.magicpatterns.com/uploads/agacHF4oUprc8XhkQK75E2/mockup_sticker.png" alt="Megapack Colorimetría Lista — Mockup completo del producto" loading="eager" decoding="async"
          // @ts-ignore — supported by modern browsers
          fetchpriority="high" className="relative block w-full max-w-[300px] md:max-w-[560px] mx-auto h-auto object-contain hover:-translate-y-1 transition-transform duration-300 drop-shadow-2xl" data-id="element-320" data-mp="fkf5vndf3vcj" />
          </a>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-321" data-mp="3s5catgdploo2">
          <div className="max-w-2xl mx-auto space-y-2.5 md:space-y-5" data-id="element-322" data-mp="3s6nezhb2gyfp">
            {/* Chips - same on all screens */}
            <div className="flex flex-wrap gap-1.5 md:gap-2 justify-center items-center" data-id="element-323" data-mp="onubxyfwzrzs">
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-324" data-mp="opos6zg8qvxj">
                <span className="text-[10px] md:text-xs" data-id="element-325" data-mp="12nlpjy2ir6d9">📄</span> 100% PDF +
                Videos HD
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-326" data-mp="17ev7sdlqn7f4">
                <span className="text-[10px] md:text-xs" data-id="element-327" data-mp="2n6fn4xegh2o8">⚡</span> Acceso en 5
                min
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-328" data-mp="31t8vfipk586x">
                <span className="text-[10px] md:text-xs" data-id="element-329" data-mp="296o76r4dpc7l">📚</span> 475+ páginas
                + 14 h de video
              </span>
            </div>

            {/* CTA button + trust */}
            <div className="space-y-2 md:space-y-3" data-id="element-330" data-mp="2i7md5eydntst">
              <CTAButton href="#pricing" fullWidth className="!py-3.5 md:!py-4 !text-[15px] md:!text-base" data-id="element-331" data-mp="2e4zd4qrjz2kj">
                🎨 DOMINA LA COLORIMETRÍA AHORA
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 text-[9.5px] md:text-xs text-txt-muted font-sans" data-id="element-332" data-mp="3tnt1fhd5hx8e">
                <span className="flex items-center gap-1" data-id="element-333" data-mp="opf9x5y5j98q">
                  <ShieldCheck size={11} className="text-success" data-id="element-334" data-mp="oqzz0g1p5zz7" /> Garantía 7
                  días
                </span>
                <span className="flex items-center gap-1" data-id="element-335" data-mp="xpv6dvgh9g43">
                  <Lock size={11} className="text-txt-muted" data-id="element-336" data-mp="xoae6chmy99e" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-337" data-mp="12pzpzucomqyj">
                  <CreditCard size={11} className="text-brandGold" data-id="element-338" data-mp="17okq7trxpamz" /> Pagas en
                  tu moneda local
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  const stats = [{
    value: '+500',
    label: 'barberos dominan con esto'
  }, {
    value: '15',
    label: 'Módulos en video'
  }, {
    value: '4',
    label: 'Manuales PDF'
  }, {
    value: '4.9/5',
    label: 'calificación',
    star: true
  }];
  return <div className="bg-bg-alt border-y border-line py-6" data-id="element-339" data-mp="1ve596co387w9">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-340" data-mp="3fv4o64c86o6b">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x divide-line" data-id="element-341" data-mp="3fwplg1pxcl7v">
          {stats.map((stat, i) => <FadeIn key={stat.label} delay={0.1 + i * 0.1} data-id="element-342" data-mp="3ayo2rhweunwx" data-mpi={i}>
              <div className="font-display font-bold text-[30px] md:text-[42px] leading-[1.1] text-brandGold mb-0.5" data-id="element-343" data-mp="35y054ddof8tq">
                {stat.value}
              </div>
              <div className="text-sm font-sans text-txt-body flex items-center justify-center gap-1" data-id="element-344" data-mp="2h1d9h3zug4p">
                {stat.label}
                {stat.star && <Star size={12} className="fill-gold text-gold" data-id="element-345" data-mp="3tnkx1lrt5gf5" />}
              </div>
            </FadeIn>)}
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'JM',
    text: 'No sabía como realizar platinados. Con esto aprendí como hacerlos. Me ayudo mucho, gracias.',
    author: 'Juan M.',
    role: 'Barbero Profesional · Argentina',
    bg: 'bg-brandGold text-[#14100A]'
  }, {
    initials: 'CS',
    text: 'Implemente el servicio de color con mi equipo. Ahora realizamos trabajos completos. Sin errores.',
    author: 'Carlos S.',
    role: 'Dueño de Barbería · México',
    bg: 'bg-brandSteel-deep text-white'
  }, {
    initials: 'RF',
    text: 'Descargué todo el curso. Ahora lo aplicamos en el local. Me ayudo mucho a comprender qué fórmula usar.',
    author: 'Roberto F.',
    role: 'Colorista · Colombia',
    bg: 'bg-brandGold text-[#14100A]'
  }];
  return <Section className="bg-bg-base" data-id="element-346" data-mp="1vz8rpu6dw3af">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5 md:gap-4" data-id="element-347" data-mp="1w0a0tt3uafpi">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-348" data-mp="1i0hcu5jp6dl8" data-mpi={i}>
            <div className="bg-bg-card p-3.5 md:p-5 rounded-[14px] md:rounded-[18px] border border-line h-full flex flex-col" data-id="element-349" data-mp="1myiuqn5e06v4">
              <div className="flex items-center gap-2.5 mb-2.5" data-id="element-350" data-mp="3cd774odz9ot5">
                <div className={`w-8 h-8 md:w-9 md:h-9 ${t.bg} rounded-full flex items-center justify-center font-sans font-bold text-[11px] md:text-xs shrink-0`} data-id="element-351" data-mp="3hcjtz94umvvq">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-352" data-mp="10qnab4eae2kn">
                  <div className="flex text-gold mb-0.5" data-id="element-353" data-mp="10ronpfirz15j">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-354" data-mp="1fft6sklqpeou" data-mpi={j} />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[12px] md:text-[13px] leading-tight" data-id="element-355" data-mp="1anj9ukm7jed2">
                    {t.author}
                  </p>
                  <p className="text-[10px] md:text-[11px] font-sans text-txt-muted" data-id="element-356" data-mp="1jgv5n0bqvoqa">
                    {t.role}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[12.5px] md:text-[13.5px] leading-[1.5] italic" data-id="element-357" data-mp="1ybjaqdd8gl5d">
                "{t.text}"
              </p>
              <p className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandGold mt-auto pt-2.5" data-id="element-358" data-mp="40w78grxj738">
                Compró el Megapack
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const UniqueMechanism = () => {
  const scattered = ['Buscaste videos en YouTube.', 'Seguiste tutoriales en Instagram.', 'Preguntaste a otros barberos.', 'Todos te enseñaron algo diferente.'];
  const chain = [{
    from: 'Diagnóstico claro',
    to: 'Fórmula exacta'
  }, {
    from: 'Fórmula exacta',
    to: 'Aplicación paso a paso'
  }, {
    from: 'Aplicación',
    to: 'Resultado garantizado'
  }];
  return <Section className="bg-bg-base" data-id="element-359" data-mp="2vcyxjdgd4jee">
      <div className="max-w-[880px] mx-auto" data-id="element-360" data-mp="2ve0ajngxvfyr">
        <FadeIn data-id="element-361" data-mp="30cbl60f25ui1">
          
        </FadeIn>

        
      </div>
    </Section>;
};
export const Problem = () => {
  const painPoints = ['Alguna vez realizaste un trabajo de color, utilizando fórmulas o técnicas, con información que encontraste por tu cuenta', 'Tienes dudas sobre la preparación exacta que necesitas para decolorar y neutralizar el cabello sin lastimarlo', 'Repites las mismas excusas porque no tienes la fórmula exacta para cada color', 'Un cliente nuevo pide un "platinado blanco" pero el trabajo te queda con reflejos amarillos', 'Conoces sobre el tema, pero no estás conforme con el resultado final por que sabes que puedes hacerlo mejor', 'Cada mes pierdes ingresos extras por rechazar trabajos o cobrarlos a un precio que no es rentable'];
  return <Section className="bg-bg-alt" data-id="element-362" data-mp="1qdskn93w1u9x">
      <div className="max-w-[720px] mx-auto" data-id="element-363" data-mp="1lf7mdf875ko4">
        <FadeIn data-id="element-364" data-mp="1lg0izndfytsj">
          <h2 className="font-display font-bold uppercase md:text-[36px] text-center mb-8 text-txt-primary text-[22px] leading-[1.25] tracking-[0.5px]" data-id="element-365" data-mp="1lgiqxh9guwga">
            Si eres  <span className="text-brandGold" data-id="element-366" data-mp="1cdrdjbx15qm0">barbero,</span>
            <br data-id="element-367" data-mp="1cgdqxs6lr0c5" />
            esto te va a sonar familiar...
          </h2>

          <div className="space-y-2 md:space-y-3 mb-10" data-id="element-368" data-mp="17hama8ujaw4p">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2.5 bg-bg-card border border-line rounded-[10px] py-2.5 px-3 md:py-3 md:px-4" data-id="element-369" data-mp="36s20tfxz8cpo" data-mpi={i}>
                <XCircle className="text-danger shrink-0 mt-0.5" size={16} data-id="element-370" data-mp="ibmv6mksbo1s" />
                <p className="text-txt-body font-sans text-[13px] md:text-[15px] leading-[1.5]" data-id="element-371" data-mp="idrbk3zvefiy">
                  {point}
                </p>
              </div>)}
          </div>

          {/* Gold divider */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mb-10 md:mb-12 bg-brandGold" style={{
          boxShadow: '0 0 12px rgba(212,162,76,0.7), 0 0 24px rgba(212,162,76,0.4)'
        }} data-id="element-372" data-mp="r9yxvmyxecal"></div>

          <h3 className="font-display font-bold uppercase md:text-[40px] text-center text-txt-primary mb-8 relative text-[24px] leading-[1.2] tracking-[0.5px]" data-id="element-373" data-mp="3qrgetaaexfn2">
            ¿Sigues improvisando{' '}
            <span className="text-brandGold inline-block" style={{
            textShadow: '0 0 20px rgba(212,162,76,0.5), 0 0 40px rgba(212,162,76,0.3)'
          }} data-id="element-374" data-mp="3mqrf1prgx6z">
             por tener un conocimiento disperso?
            </span>
          </h3>

          <div className="space-y-4 text-txt-body font-sans text-[15px] md:text-base leading-[1.7] mb-10" data-id="element-375" data-mp="372pizijvnt5m">
            <p style={{
            paddingLeft: "10px"
          }} data-id="element-376" data-mp="1mjvhw98qfepw">
              Elegiste este camino porque amás esta profesión, trabajar en la imagen de las personas y ganar dinero en serio.
            </p>
            <p style={{
            paddingLeft: "9px"
          }} data-id="element-377" data-mp="1dml3wg4j5bha">
              Pero nadie te dijo que ibas a perder tiempo y dinero, improvisando con tus clientes, intentando descubir EL SECRETO EXACTO que utilizan los barbéros: dónde TODO esté organizado, donde NO FALLES y
              puedas COBRAR lo que realmente vale tu trabajo.
            </p>
          </div>

          {/* Highlighted closing question */}
          <div className="relative bg-bg-card border-2 border-brandGold rounded-[16px] py-5 px-5 md:py-6 md:px-8 shadow-[0_0_40px_rgba(212,162,76,0.2)]" data-id="element-378" data-mp="1wdm4t9p7nh3h">
            <p className="font-display font-bold text-[18px] md:text-[26px] leading-[1.3] text-center text-txt-primary uppercase tracking-[0.5px]" data-id="element-379" data-mp="kvb94fdbxwiv">
              ¿Y SI HOY TUVIERAS TODO LISTO PARA{' '}
              <span className="text-brandGold" data-id="element-380" data-mp="5rrpe4vlwf8o">DOMINAR LA TÉCNICA?</span>
            </p>
          </div>

          {/* Gold divider — transition to product */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mt-10 md:mt-14 bg-brandGold" style={{
          boxShadow: '0 0 12px rgba(212,162,76,0.7), 0 0 24px rgba(212,162,76,0.4)'
        }} data-id="element-381" data-mp="3t5vj8cxsp1dy"></div>
        </FadeIn>
      </div>
    </Section>;
};